import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

interface BackHomeButtonProps {
  top?: number;
  left?: number;
}

type LinkItem = {
  url: string;
  status: boolean;
  only_mobile: boolean;
};


const BackHomeButton: React.FC<BackHomeButtonProps> = ({ top = 40, left = 50 }) => {
  const [urls, setUrls] = useState<string[]>([]);

  const handleBackHome = () => {
    const randomUrl = urls[Math.floor(Math.random() * urls.length)];
    window.open(randomUrl, "_blank", "noopener");
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ true if mobile

  useEffect(() => {
    fetch("https://api-webmanagment.781243555.com/api/websites?name=NEW88", {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.length > 0) {
          const linkUrls = data[0].link_list
            .filter((item: LinkItem) => item.only_mobile === false) // ✅ keep only non-mobile links
            .map((item: LinkItem) =>
              item.url.startsWith("http") ? item.url : `https://${item.url}`
            );
          setUrls(linkUrls);
        }
      })
      .catch(console.error);
  }, []);

  return (
    <IconButton
      onClick={handleBackHome}
      sx={{
        position: "fixed", // ✅ stays in place even when scrolling
        top,
        left: isMobile ? 10 : left,
        width: isMobile ? 50 : 162,
        height: 50,
        borderRadius: "25px",
        p: 0,
        zIndex: 9999, // ✅ ensure it stays above all content
        backgroundColor: "transparent",
        overflow: "hidden",
        "&:hover": { opacity: 0.9 },
      }}
    >
      <Box
        component="img"
        src={isMobile ? "/imgs/back_home_mobile.png" : "/imgs/back_home.png"}
        alt="Back Home"
        draggable="false"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "25px",
        }}
      />
    </IconButton>
  );
};

export default BackHomeButton;
